import { HttpInterceptorFn } from '@angular/common/http';

/**
 * Production stub for `mock-api.providers.ts` (swapped in via angular.json
 * `fileReplacements`).
 *
 * It intentionally imports no mock code, so `mock-api.interceptor` and every
 * `mock-data/` fixture (demo passwords, synthetic child records) never enter
 * the production import graph and are excluded from the shipped bundle.
 */
export const mockApiInterceptors: HttpInterceptorFn[] = [];
